// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__3BsWF","container":"about_container__35ZZ8","sectitel":"about_sectitel__3Kt3c","aboutdes":"about_aboutdes__2CJn9"};